module.exports = __webpack_public_path__ + "assets/img/2019_2.72a726ee.png";